import { useRoutes } from 'react-router-dom'
import { routes } from 'routes'

import Header from 'modules/Header'
import Footer from 'modules/Footer'

import style from './index.module.scss'

const layoutRegistry = {
  header: Header,
  footer: Footer,
  game: ({ children }) => children,
  main: ({ children }) => <main className={style.main}>{children}</main>,
}

const withLayout = (route) => {
  const { element, layout = [] } = route

  const layoutElements = layout.map((key, idx) => {
    const Component = layoutRegistry[key]
    if (!Component) return null

    if (key === 'main' || key === 'game') {
      return <Component key={idx}>{element}</Component>
    }

    return <Component key={idx} />
  })

  return {
    ...route,
    element: layoutElements,
  }
}

const AppRoutes = () => {
  const wrappedRoutes = routes.map((route) => withLayout(route))
  return useRoutes(wrappedRoutes)
}

export default AppRoutes
